/* Delivery address checker and delivery quote form (Delivery checker section).
   The customer enters the delivery address (street plus suburb). The price comes from the same script
   checkout uses (blossom-delivery /check, data-api), so the price shown here is the price charged at checkout.
   suburbs.json holds [name, postcode, lat, lon, driving km]; here it fills the suburb list and finds the postcode. */
(function () {
  'use strict';
  function money(c) { return '$' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); }
  function setup(sec) {
    if (!sec || sec._c) return;
    var B = window.BBC;
    if (!B) return;
    sec._c = 1;
    var form = sec.querySelector('[data-sub-form]'),
      street = form.querySelector('[data-street]'),
      input = form.querySelector('[data-suburb]'),
      btn = form.querySelector('button[type="submit"]'),
      out = sec.querySelector('[data-sub-res]'),
      dl = form.querySelector('datalist'),
      quote = sec.querySelector('[data-quote]'),
      quoteAddr = quote && quote.querySelector('[data-quote-addr]'),
      api = sec.getAttribute('data-api'),
      phone = sec.getAttribute('data-phone') || '',
      tel = phone.replace(/\s/g, ''),
      SUB = null, wait = null, busy = false, seen = {},
      tiers = Array.prototype.slice.call(sec.querySelectorAll('[data-tiers] li')).map(function (li) {
        return { el: li, km: +li.getAttribute('data-km') || 0 };
      }).filter(function (t) { return t.km > 0; }).sort(function (a, b) { return a.km - b.km; });

    function load() {
      return wait || (wait = fetch(sec.getAttribute('data-src')).then(function (r) { return r.json(); }).then(function (d) {
        SUB = d;
        dl.innerHTML = d.map(function (s) { return '<option value="' + B.esc(s[0] + ' ' + s[1]) + '">'; }).join('');
        return d;
      }).catch(function () { SUB = []; }), wait);
    }
    function call() {
      return phone ? ' Or call us on <a href="tel:' + B.esc(tel) + '">' + B.esc(phone) + '</a>.' : '';
    }
    function showQuote(prefill) {
      if (!quote) return '';
      quote.hidden = false;
      // Fill the quote form's address with the one just checked, unless the customer typed their own.
      if (quoteAddr && prefill && (!quoteAddr.value || quoteAddr._auto === quoteAddr.value)) quoteAddr.value = quoteAddr._auto = prefill;
      return ' <a href="#quote" data-quote-go>Ask for a quote</a>.';
    }
    function say(html) { out.innerHTML = '<p>' + html + '</p>'; }
    function top(place, fee) {
      return '<div class="sr-top"><span class="sr-name">' + B.esc(place) + '</span><span class="sr-fee">' + fee + '</span></div>';
    }
    function clean(v) { return String(v || '').replace(/\s+/g, ' ').trim(); }

    // Suburb box: "Norwood", "Norwood 5067", "Norwood SA 5067" or "5067".
    // Returns [suburb entry, suburb name to send] or null. With only a postcode (or a name we do not know
    // in that postcode), no suburb name is sent, so the address is street plus postcode.
    function findSuburb(q) {
      q = clean(q).toLowerCase().replace(/[,\s]*australia$/, '');
      var pc = (q.match(/\b\d{4}\b/) || [])[0],
        name = q.replace(/\b\d{4}\b/, '').replace(/[,\s]+(sa|south australia)\s*$/, '').replace(/^[,\s]+|[,\s]+$/g, ''),
        lc = function (x) { return x[0].toLowerCase(); },
        s = name && SUB.filter(function (x) { return lc(x) === name && (!pc || String(x[1]) === pc); })[0];
      if (s) return [s, s[0]];
      s = name && !pc && SUB.filter(function (x) { return lc(x).indexOf(name) === 0; })[0];
      if (s) return [s, s[0]];
      s = pc && SUB.filter(function (x) { return String(x[1]) === pc; })[0];
      return s ? [s, ''] : null;
    }

    // A whole address pasted into the street box ("12 Osmond Tce, Norwood SA 5067"): split it into the two boxes.
    function splitFull() {
      if (clean(input.value)) return;
      var t = clean(street.value).replace(/[,\s]*australia$/i, ''), pc = (t.match(/\b(\d{4})$/) || [])[1];
      if (pc) t = t.replace(/[,\s]*\d{4}$/, '');
      t = t.replace(/[,\s]+(sa|south australia)$/i, '');
      var low = t.toLowerCase(), best = null;
      SUB.forEach(function (x) {
        var n = x[0].toLowerCase();
        if ((!pc || String(x[1]) === pc) && low.length > n.length + 2 && (low.slice(-n.length - 1) === ' ' + n || low.slice(-n.length - 1) === ',' + n) && (!best || n.length > best[0].length)) best = x;
      });
      if (best) {
        street.value = t.slice(0, t.length - best[0].length).replace(/[,\s]+$/, '');
        input.value = best[0] + ' ' + best[1];
      } else if (pc) {
        street.value = t.replace(/[,\s]+$/, '');
        input.value = pc;
      }
    }

    function show(d, place) {
      tiers.forEach(function (t) { t.el.classList.remove('hit'); });
      if (!d.deliver) {
        out.innerHTML = top(place, 'Quote') + '<p>' + (typeof d.km === 'number' ? 'This address is ' + Math.floor(d.km) + ' km by road, outside' : 'This address is outside') +
          ' our standard delivery area. Send us the address and we will come back to you with a price or other options.' + showQuote(place) + call() + '</p>';
        return;
      }
      var hit = tiers.filter(function (t) { return d.km < t.km; })[0],
        c = B.cutoffState(),
        when = c.today ? 'Order within <b>' + c.txt + '</b> for delivery today, before 5.30pm.' : 'Order now for delivery ' + c.next + ', before 5.30pm.';
      if (hit) hit.el.classList.add('hit');
      out.innerHTML = top(place, money(d.fee)) + '<p>' + (d.km < 1 ? 'Under 1' : Math.floor(d.km)) + ' km by road from our studio, so delivery is <b>' + money(d.fee) + '</b> at checkout.' +
        (d.free ? ' Free on orders of ' + money(d.free) + ' or more.' : '') +
        (d.min ? ' Orders under ' + money(d.min) + ' are pick up only.' : '') + ' ' + when + '</p>';
    }

    function check() {
      if (!SUB) { load().then(check); return; }
      tiers.forEach(function (t) { t.el.classList.remove('hit'); });
      splitFull();
      var st = clean(street.value), q = clean(input.value);
      if (!st && !q) { out.innerHTML = ''; return; }
      if (!q) { say('Add the suburb or postcode too.'); input.focus(); return; }
      var f = findSuburb(q);
      if (!f) {
        say('We could not find that suburb. Pick it from the list, or if it is outside Adelaide (SA), send us the address for a price.' + showQuote(clean(st + ', ' + q).replace(/^, /, '')) + call());
        return;
      }
      var s = f[0], sub = f[1], pc = String(s[1]);
      if (sub) input.value = s[0] + ' ' + pc;
      if (st.length < 3) { say('Add the street address too, so we can give you the exact price.'); street.focus(); return; }
      var place = st + ', ' + (sub ? sub + ' ' : '') + pc, key = place.toLowerCase();
      if (seen[key]) { show(seen[key], place); return; }
      if (busy) return;
      busy = true;
      var label = btn.textContent, ctl = window.AbortController ? new AbortController() : null,
        timer = setTimeout(function () { if (ctl) ctl.abort(); }, 9000);
      btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Checking';
      fetch(api, { method: 'POST', body: JSON.stringify({ street: st, suburb: sub, postcode: pc }), credentials: 'omit', signal: ctl ? ctl.signal : undefined })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok || typeof d.deliver !== 'boolean') throw d; return d; }); })
        .then(function (d) { seen[key] = d; show(d, place); })
        .catch(function () { tiers.forEach(function (t) { t.el.classList.remove('hit'); }); say('We could not check that address just now. Please try again in a moment.' + call()); })
        .then(function () { clearTimeout(timer); busy = false; btn.disabled = false; btn.removeAttribute('aria-busy'); btn.textContent = label; });
    }

    street.addEventListener('focus', load, { once: true });
    input.addEventListener('focus', load, { once: true });
    form.addEventListener('submit', function (e) { e.preventDefault(); check(); if (document.activeElement && document.activeElement.blur) document.activeElement.blur(); });
    // Picking a suburb from the list checks straight away once there is a street.
    input.addEventListener('change', function () { if (clean(street.value)) check(); });
    if (quote) {
      // Open the form after it was sent (Shopify reloads the page) or when linked to #quote.
      if (/contact_posted=true/.test(location.search) || quote.querySelector('.quote-ok, .quote-err') || location.hash === '#quote') {
        quote.hidden = false;
        if (location.hash === '#quote' || /contact_posted=true/.test(location.search)) setTimeout(function () { quote.scrollIntoView({ block: 'start' }); }, 50);
      }
      var openQuote = function () {
        quote.hidden = false;
        quote.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var f = quote.querySelector('input[name="contact[name]"]');
        if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 400);
      };
      // "Ask for a quote" links, in the result or anywhere on the page (href="#quote").
      document.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('[data-quote-go], a[href="#quote"]');
        if (!a) return;
        e.preventDefault();
        openQuote();
      });
      window.addEventListener('hashchange', function () { if (location.hash === '#quote') openQuote(); });
    }
  }
  function all() { Array.prototype.forEach.call(document.querySelectorAll('[data-checker]'), setup); }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', all) : all();
  document.addEventListener('shopify:section:load', all);
})();
